module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/berries@3x_6dc3d9.jpg";